var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgVolumeNone = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.26 0.207515C11.4165 0.0943724 11.5997 0.024701 11.7911 0.00545685C11.9826 -0.0137873 12.1758 0.0180691 12.3512 0.0978454C12.5267 0.177622 12.6785 0.302526 12.7912 0.460087C12.904 0.617649 12.9739 0.802354 12.994 0.99576L13 1.11097V16.888C13.0001 17.0825 12.9496 17.2736 12.8538 17.4422C12.7579 17.6108 12.6199 17.7511 12.4536 17.8489C12.2874 17.9468 12.0986 17.9989 11.9061 18C11.7137 18.0011 11.5244 17.9511 11.357 17.8551L11.261 17.7925L4.68 13.0418H2C1.49542 13.0419 1.00943 12.8494 0.639452 12.5026C0.269471 12.1559 0.0428435 11.6807 0.0050003 11.1722L1.00166e-07 11.0206V6.97834C-0.000159498 6.46843 0.190407 5.9773 0.533497 5.60341C0.876588 5.22952 1.34684 5.0005 1.85 4.96225L2 4.9572H4.68L11.26 0.207515ZM19.6667 6.64297C20.0348 7.01116 20.0348 7.6081 19.6667 7.97629L18.3333 9.30963L19.6666 10.6429C20.0348 11.0111 20.0348 11.6081 19.6666 11.9763C19.2984 12.3444 18.7015 12.3444 18.3333 11.9763L17 10.643L15.6667 11.9763C15.2985 12.3444 14.7016 12.3444 14.3334 11.9763C13.9652 11.6081 13.9652 11.0111 14.3334 10.6429L15.6667 9.30963L14.3333 7.97629C13.9652 7.6081 13.9652 7.01116 14.3333 6.64297C14.7015 6.27478 15.2985 6.27478 15.6667 6.64297L17 7.97631L18.3333 6.64297C18.7015 6.27478 19.2985 6.27478 19.6667 6.64297Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgVolumeNone);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/volume-none.09c6c4e7e25e05b53d6b56e623ef7233.svg";